import axios from 'axios';
import qs from 'qs';

import { addOptionsToParams, getAccessToken } from './common';
import * as Constants from './constants';
import { attachCorrelationIdHeader, storeCorrelationIdFromHeaders } from './correlationId';

const api_request = async ({ methodType, resourcePath, params, data, options, signal, isSI, isMDM = false }) => {
  const headers = attachCorrelationIdHeader(getAccessToken());
  const isMultipartData = addMultipartData(resourcePath);
  if (isMultipartData) {
    headers['Content-Type'] = 'multipart/form-data';
  }

  let baseURL = isSI ? Constants.PATH.SI_BASE_URL : Constants.PATH.PO_BASE_URL;
  if (isMDM) {
    baseURL = Constants.PATH.MDM_BASE_URL;
  }

  try {
    const responseData = await axios({
      ...(signal ? { signal } : ''),
      method: methodType,
      baseURL,
      url: `${resourcePath}`,
      headers,
      ...(params ? { params } : ''),
      ...(data ? { data } : ''),
      ...(options ? addOptionsToParams(options) : ''),
      paramsSerializer(params) {
        return qs.stringify(params, {
          encode: true
        });
      }
    });
    storeCorrelationIdFromHeaders(responseData.headers);
    return responseData;
  } catch (err) {
    storeCorrelationIdFromHeaders(err.response?.headers);
    throw err;
  }
};

const addMultipartData = (resourcePath) => {
  const multipartResourcePath = [
    `${Constants.PATH.PURCHASE_ORDER.commentsUpload}`,
    `${Constants.PATH.PURCHASE_ORDER.validateSKU}`,
    `${Constants.PATH.ATTACHMENT.upload}`,
    `${Constants.PATH.ASN.commentsUpload}`,
    `${Constants.PATH.SALES.SALES_ORDER.validateSKU}`,
    `${Constants.PATH.SALES.CUSTOMER_PO.allocatePO}`,
    `${Constants.PATH.SALES.SALES_ORDER.validateSOPack}`,
    `${Constants.PATH.SALES.SALES_ORDER.addAppointment}`,
    `${Constants.PATH.SALES.SALES_ORDER.editAppointment}`,
    `${Constants.PATH.SALES.SALES_ORDER.uploadEpod}`,
    `${Constants.PATH.SALES.SALES_ORDER.epodManualUpload}`,
    `${Constants.PATH.SALES.SALES_ORDER.bulkEpodManualUploadValidate}`,
    `${Constants.PATH.SALES.SALES_ORDER.bulkEpodManualUploadSubmit}`,
    `${Constants.PATH.SALES.SALES_ORDER.submitSKU}`,
    `${Constants.PATH.SALES.SALES_ORDER.packingDetailsValidate}`,
    `${Constants.PATH.SALES.BULK_APPOINTMENT_DOWNLOAD.download}`
  ];
  if (resourcePath.includes(Constants.PATH.GRN.commentsUpload) && resourcePath.includes(Constants.PATH.GRN.grn)) {
    return false;
  }
  if (resourcePath.includes(Constants.PATH.SALES.GRN.submitSKU)) {
    return false;
  }
  if (
    resourcePath.includes(Constants.PATH.PURCHASE_ORDER.skuSubmitUpdateQty) &&
    resourcePath.includes(Constants.PATH.PURCHASE_ORDER.po_order)
  ) {
    return false;
  }
  const found = multipartResourcePath.filter((item) => resourcePath.includes(item));
  if (found.length > 0) {
    return true;
  }
  return false;
};

export { api_request };
